import type { IFlightSegmentConnectorProps } from "@b2bportal/core-flights";
import { IconNameEnum } from "@b2bportal/core-themes";
import { Icon } from "@tenant/ui";

export const FlightSegmentConnector = ({
  classNames,
}: IFlightSegmentConnectorProps) => (
  <div className={classNames?.root}>
    <Icon
      className={classNames?.marker}
      iconName={IconNameEnum.airplaneDeparture}
      useCurrentColor
    />
    <div className={classNames?.line}></div>
    <Icon
      className={classNames?.marker}
      iconName={IconNameEnum.airplaneArrive}
      useCurrentColor
    />
  </div>
);
